module.exports = __webpack_public_path__ + "img/sk.0c483c31.svg";